/*!
 * AudoChat - App Layout Component
 */

import Sidenav from "examples/Sidenav";
import { useVisionUIController } from "context";
import routes from "routes";

function AppLayout({ onMouseEnter, onMouseLeave }) {
  const [controller] = useVisionUIController();
  const { sidenavColor } = controller;

  return (
    <>
      <Sidenav
        color={sidenavColor}
        brand=""
        brandName="AudoChat"
        routes={routes}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </>
  );
}

export default AppLayout;

